//on job edit page list for dom content changes
import * as uiv from "uiv";
import { getRundeckContext } from "../../library";
import { UiMessage } from "../../library/stores/UIStore";
import UiSocket from "../../library/components/utils/UiSocket.vue";
import { initI18n, commonAddUiMessages, type LocalizedMessages } from "./i18n";
import { createApp } from "vue";
import { configurePrimeVue } from "../../library/utilities/primeVueConfig";

export const observer = new MutationObserver(function (mutations_list) {
  mutations_list.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (added_node) {
      if (added_node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }
      const added_elem = added_node as Element;
      const uiSockets = added_elem.getElementsByClassName("vue-ui-socket");

      if (added_elem.className && uiSockets?.length > 0) {
        const i18n = initI18n();
        const rootStore = getRundeckContext().rootStore;
        const eventBus = getRundeckContext().eventBus;

        for (const socketElem of uiSockets) {
          const vue = createApp(
            {
              name: "DynamicUiSocketRoot",
              components: { UiSocket },
              provide: {
                rootStore,
              },
              props: ["eventBus"],
              inject: ["addUiMessages"],
            },
            {
              eventBus,
            },
          );

          vue.provide(
            "addUiMessages",
            async (messages: UiMessage[] | LocalizedMessages) =>
              commonAddUiMessages(i18n, messages),
          );

          vue.use(i18n);
          vue.use(uiv);
          configurePrimeVue(vue, { includeTooltip: true });
          vue.mount(socketElem, true);
        }
      }
    });
  });
});
